<i18n>
{
  "en": {
    "masterProductTitle": "Edit: {0}",
    "masterProductSubTitle": "The changes will be applied after republishing",
    "commercialName": "Name",
    "commercialNameHint": "Name of the product when displayed in the menu",
    "commercialDescription": "Description",
    "commercialDescriptionHint": "Description of the product displayed under the name",
    "longCommercialDescription": "Popup Description",
    "longCommercialDescriptionHint": "Description of the product when clicked to view more details",
    "outOfStock": "Out of stock",
    "image": "Image in menu",
    "imageHint": "Image to show in the popup of the product, right not there is no image",
    "imageHintExisting": "Image to show in the popup of the product, Warning, the current one will be overridden!",
    "videoHint": "Video to show in the popup of the product, right not there is no video",
    "videoHintExisting": "Video to show in the popup of the product, Warning, the current one will be overridden!",
    "unitCost": "Unit cost",
    "unitCostHint": "The cost to produce each unit of product",
    "referencePrice": "Reference price",
    "referencePriceHint": "Starting price for optimization process",
    "maxRangePrice": "Maximum allowed price",
    "maxRangePriceHint": "Only enforced in the optimizer",
    "minRangePrice": "Minimum allowed price",
    "minRangePriceHint": "Only enforced in the optimizer",
    "processingSpeed": "Processing Speed",
    "processingSpeedHint": "Being 5 the slowest in the restaurant and 1 the fastest",
    "consumptionPerPerson": "Consumption per person",
    "consumptionPerPersonHint": "How many units of product does each diner eat",
    "soldByWeight": "Sold by weight",
    "saleWeight": "Percentage of product",
    "saleWeightHint": "How much of the product is sold on each dish (1-1000)",
    "isManaged": "Revenue managed",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "confirmTitle": "Are you sure you want to save the changes?",
    "confirmText": "This cannot be undone",
    "invalidNumberError": "Invalid number",
    "tooShortText": "Input text is too short",
    "tooLongText": "Input text is too long",
    "invalidPercentage": "A valid integer between 1 and 100 is required",
    "defaultSettings": "Hide advanced settings",
    "advancedSettings": "Show advanced settings",
    "features": "Allergens and other features",
    "featuresHint": "Different properties of the current product",
    "fileSizeError": "File too big, should not exceed 2MB",
    "fileVideoSizeError": "File too big, should not exceed 10MB",
    "validationError": "Please, review all fields",
    "errorInProduct": "Wrong product",
    "previousFile": "Previous File",
    "referencePriceBetween": "Reference price must be between max and min allowed price, if specified",
    "typeToSearch": "Type to search",
    "masterSaleFormat": "Master sale format",
    "emptyFieldError": "Required field",
    "existingSaleFormat": "This sale format already has a main product",
    "textAttributes": "Textual attributes",
    "preparationAttributes": "Preparation attributes",
    "productPrices": "Product prices",
    "imageAndFeatures": "Image, features and tags",
    "saleFormats": "Subordinate sale formats",
    "saleFormatsSetup": "Setup subordinate sale formats",
    "en": "English",
    "es": "Spanish",
    "selectLanguage": "Language",
    "missingProduct": "Can't find product",
    "saveProductSuccess": "Product updated successfully",
    "saveProductError": "There was an error saving the product, try again later",
    "deleteSaleFormat": "Delete",
    "deleteSaleFormatTitle": "Are you sure to delete the sale format \"{0}\"?",
    "deleteSaleFormatDescription": "This change will cause sales formats lower than this to be deleted too.",
    "delete": "Delete",
    "groupOfProductPricing": "Group of products for pricing",
    "groupOfProductPricingHint": "Group for related products for price calculations",
    "groupOfProductPricingError": "Group of product is mandatory",
    "saleFormatLengthError": "The number of sale formats per master sale format of the new group must be the same as the old one",
    "ignoreDynamicVisibility": "Forbids menu engineering to hide this product in the menu",
    "saveDelay": "This process may take a while. Please hold on until it finishes.",
    "fileFormatError": "This format is not valid",
    "productMasterProduct":  "Product Master",
    "productMasterProductHint": "Assign a master product for this product",
    "tags": "Tag"
  },
  "es": {
    "masterProductTitle": "Editar: {0}",
    "masterProductSubTitle": "Los cambios se aplicarán después de volver a publicar",
    "commercialName": "Nombre",
    "commercialNameHint": "Nombre del producto tal y como se ve en el menú",
    "commercialDescription": "Descripción",
    "commercialDescriptionHint": "Descripción del producto que se muestra debajo del nombre en el menú",
    "longCommercialDescription": "Descripción emergente",
    "longCommercialDescriptionHint": "Descripción del producto que se muestra tras hacer click en él",
    "outOfStock": "Sin stock",
    "image": "Imagen en menú",
    "imageHint": "Imagen a mostrar tras hacer click en él, ahora mismo no tiene imagen",
    "imageHintExisting": "Imagen a mostrar tras hacer click en él, ¡cuidado, la imagen existente se sobrescribirá!",
    "videoHint": "Video a mostrar tras hacer click en él, ahora mismo no tiene video",
    "videoHintExisting": "Video a mostrar tras hacer click en él, ¡cuidado, la imagen existente se sobrescribirá!",
    "unitCost": "Coste unitario",
    "unitCostHint": "El coste de producir cada unidad del producto",
    "referencePrice": "Precio de referencia",
    "referencePriceHint": "El precio que utilizará el optimizador de precios como punto de inicio en los cálculos",
    "maxRangePrice": "Máximo precio permitido",
    "maxRangePriceHint": "Solo se impone en el optimizador",
    "minRangePrice": "Mínimo precio permitido",
    "minRangePriceHint": "Solo se impone en el optimizador",
    "processingSpeed": "Velocidad de preparación",
    "processingSpeedHint": "Siendo 5 lo más lento de todo el restaurante y 1 lo más rápido",
    "consumptionPerPerson": "Consumo por persona",
    "consumptionPerPersonHint": "Cuantas unidades de producto consume cada comensal",
    "soldByWeight": "Vendido al peso",
    "saleWeight": "Porcentaje del producto",
    "saleWeightHint": "Qué porcentaje del producto se vende en cada plato (1-1000)",
    "isManaged": "Gestión de ingresos activa",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "confirmTitle": "¿Estás seguro de que deseas guardar los cambios?",
    "confirmText": "Esto no se puede deshacer",
    "invalidNumberError": "Por favor, introduce un número válido",
    "tooShortText": "El texto es demasiado corto",
    "tooLongText": "El texto es demasiado largo",
    "invalidPercentage": "Es necesario introducir un número entero entre 1 y 100",
    "defaultSettings": "Ocultar opciones avanzadas",
    "advancedSettings": "Mostrar opciones avanzadas",
    "features": "Alérgenos y otras características",
    "fileSizeError": "Archivo demasiado grande, no debe de superar los 2MB",
    "fileVideoSizeError": "Archivo demasiado grande, no debe de superar los 10MB",
    "validationError": "Por favor, revise todos los campos",
    "errorInProduct": "Product erróneo",
    "previousFile": "Archivo anterior",
    "referencePriceBetween": "El precio de referencia tiene que estar entre el máximo y el mínimo, en caso de que se especifiquen",
    "typeToSearch": "Escribe para buscar",
    "masterSaleFormat": "Formato de venta maestro",
    "emptyFieldError": "Campo obligatorio",
    "existingSaleFormat": "El formato de venta ya tiene un producto principal",
    "textAttributes": "Atributos textuales",
    "preparationAttributes": "Atributos de preparación",
    "productPrices": "Precios de producto",
    "imageAndFeatures": "Imagen, alérgenos, tags",
    "saleFormats": "Formatos de venta subordinados",
    "saleFormatsSetup": "Configurar formatos de venta subordinados",
    "en": "Inglés",
    "es": "Español",
    "selectLanguage": "Idioma",
    "saveProductSuccess": "Producto actualizado correctamente",
    "saveProductError": "Hubo un error actualizando el producto, inténtelo de nuevo más tarde.",
    "missingProduct": "No se encuentra el producto",
    "deleteSaleFormatTitle": "¿Estás seguro de borrar el formato de venta \"{0}\"?",
    "deleteSaleFormatDescription": "Este cambio va a provocar que se borren también los formatos de venta inferiores a este.",
    "deleteSaleFormat": "Eliminar",
    "groupOfProductPricing": "Grupo de productos para precios",
    "groupOfProductPricingHint": "Grupo para productos relacionados a la hora de calcular precios",
    "groupOfProductPricingError": "El grupo de productos para precios es obligatorio",
    "saleFormatLengthError": "El número de formatos de venta del nuevo grupo debe ser el mismo que el antiguo",
    "ignoreDynamicVisibility": "Impide a ingeniería de menú sacar a este producto de la carta",
    "saveDelay": "Este proceso puede tardar un rato. Por favor, espere a que termine.",
    "fileFormatError": "Este formato no es valido",
    "productMasterProduct":  "Producto maestro",
    "productMasterProductHint": "Asignar un producto maestro para este producto",
    "tags":  "Tag"
  }
}
</i18n>

<template>
  <v-dialog @click:outside="onCancel" v-model="visible" max-width="600px" scrollable persistent>
    <dynameat-confirmation-modal :visible="confirmModalVisible" :title="$t('confirmTitle')"
                                 :description="$t('confirmText')" :confirm-text="$t('confirm')"
                                 @confirm="onEditProduct" @cancel="onCloseConfirmModal"/>
    <v-card height="100%" class="px-7 py-5">
      <div class="d-flex align-center justify-space-between mb-2">
        <v-card-title class="word-break pa-0">
          {{ this.$t('masterProductTitle', [title]) }}
        </v-card-title>
      </div>
      <v-container class="pa-0">
        <v-form v-model="valid"
                class="d-flex flex-column align-left master-product-form form-inputs" ref="form">
          <DynameatLangugageFieldGenerator
            v-model="commercialNames"
            :label="$t('commercialName')"
            :type="'textField'"
            :hint="$t('commercialNameHint')"
            :rules="shortTextRulesOrEmpty"
            required
          />
          <DynameatLangugageFieldGenerator
            v-model="commercialDescriptions"
            :label="$t('commercialDescription')"
            :type="'textArea'"
            :hint="$t('commercialDescriptionHint')"
            :rules="longTextRules"
          />
          <DynameatLangugageFieldGenerator
            v-model="longCommercialDescriptions"
            :label="$t('longCommercialDescription')"
            :type="'textArea'"
            :hint="$t('longCommercialDescriptionHint')"
            :rules="longTextRules"
          />
          <v-switch v-model="outOfStock" class="mb-0" dense :label="$t('outOfStock')"/>
          <v-select v-model="masterSaleFormat" :items="mainSaleFormatList"
                    :label="$t('masterSaleFormat')" class="required"
                    item-value="guid" item-text="title" :rules="notEmptyObject" required/>
          <v-select v-model="productMaster"
                    :items="productMasterList"
                    :label="$t('productMasterProduct')" item-value="guid" item-text="name"
                    :hint="$t('productMasterProductHint')" persistent-hint chips/>

          <div class="d-flex justify-end mb-5">
            <v-sheet elevation="1" @click="switchAdvancedOptions" class="px-2 pb-2 pointer">
              {{ extraText }}
            </v-sheet>
          </div>

          <transition name="progress" mode="out-in">
            <div key="advanced" v-show="advancedOptions" class="slide-item form-inputs">

              <dynameat-modal-header v-if="masterSaleFormat" :title="$t('saleFormats')"/>
              <!-- Collapsible sales format -->
              <v-expansion-panels accordion v-if="masterSaleFormat">
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    {{$t('saleFormatsSetup')}}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div v-for="(masterFormat, index) in subordinateMasterFormats" class="pt-2 pb-0"
                         :key="index">
                      <span class="text--secondary">{{ masterFormat.title }}</span>
                      <div class="d-flex flex-row justify-space-between align-center">
                        <dynameat-autocomplete v-model="productSaleFormats[masterFormat.guid]"
                                               :prepend-icon="showSaleFormatPrependIcon"
                                               :append-icon="showSaleFormatAppendIcon"
                                               :items="productsToSearch" :filter="onProductTextFilter"
                                               :placeholder="$t('typeToSearch')" item-text="name"
                                               item-value="guid"
                                               chips :rules="uniqueSaleFormatRules" persistent-hint
                                               :cssClass="{'mr-3': true}"
                                               :disabled="!canEditSaleFormats"
                                               @click:append.stop.prevent="onEditSubordinateProduct(getProductFromGuid(productSaleFormats[masterFormat.guid]))">
                          <template v-slot:item="data">
                            <template>
                              <v-list-item-avatar>
                                <v-img :src="data.item.image" :alt="data.item.name"
                                       :lazy-src="defaultProductImg" contain/>
                              </v-list-item-avatar>
                              <v-list-item-content class="h-scroll">
                                <v-list-item-title class="no-wrap">
                                  {{ data.item.commercial_name }}
                                  (
                                  {{currency.hasLeftPosition() ? currency.symbol : ''}}
                                  {{ data.item.first_price }}
                                  {{currency.hasRightPosition() ? currency.symbol : ''}}
                                  )
                                </v-list-item-title>
                                <v-list-item-subtitle class="no-wrap">
                                  {{ data.item.name }} ({{ data.item.id_external }})
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </template>
                          </template>
                          <template v-slot:selection="data">
                            <v-chip :class="{'error-chip': data.item.is_missing}"
                                    class="caption | d-flex justify-center align-center"
                                    :disabled="!canEditSaleFormats" :close="canEditSaleFormats"
                                    @click.stop.prevent="onEditSubordinateProduct(data.item)"
                                    @click:close="onRemoveSubordinateProduct(index)">
                              <div class="chip-ellipsis">{{ data.item.name }}</div>
                            </v-chip>
                          </template>
                        </dynameat-autocomplete>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <!-- END Collapsible sales format -->

              <dynameat-confirmation-modal
                :title="$t('deleteSaleFormatTitle', [this.saleFormatName])"
                :visible="deleteSaleFormatsModalVisible"
                :description="$t('deleteSaleFormatDescription')"
                :confirm-text="$t('deleteSaleFormat')"
                @confirm="confirmDeleteSaleFormats" @cancel="cancelDeleteSaleFormats"/>
              <dynameat-modal-header :title="$t('imageAndFeatures')"/>
              <v-file-input class="pt-0" v-model="imageFile" :rules="imageRules"
                            accept="image/png, image/jpeg, image/bmp"
                            prepend-inner-icon="mdi-camera" prepend-icon=""
                            :hint="imageHint" show-size persistent-hint
              />
              <v-file-input class="pt-0" v-model="videoFile" :rules="videoRules"
                            accept="video/mp4"
                            prepend-inner-icon="mdi-video" prepend-icon=""
                            :hint="videoHint" show-size persistent-hint
              />
              <v-select v-model="features" :items="masterFeatureList"
                        :menu-props="{ maxHeight: '400' }"
                        :label="$t('features')" item-value="guid" item-text="legendName"
                        chips required multiple/>
              <v-select v-model="tags" :items="masterTagList"
                        :menu-props="{ maxHeight: '400' }"
                        :label="$t('tags')" item-value="guid" item-text="legendName"
                        chips required multiple/>
              <v-switch v-model="soldByWeight" dense :label="$t('soldByWeight')"
                        class="pt-2 mt-0 master-product-input"/>
              <v-text-field v-if="soldByWeight" v-model="saleWeight" :rules="percentageRules"
                            :label="$t('saleWeight')"
                            :hint="$t('saleWeightHint')" suffix="%" persistent-hint required/>
              <v-switch v-model="isManaged" dense :label="$t('isManaged')"
                        class="pt-2 mt-0 pb-2 master-product-input"/>
              <transition name="progress" mode="out-in">
                <div v-if="isManaged" class="form-inputs">
                  <dynameat-modal-header :title="$t('preparationAttributes')"/>
                  <v-text-field v-model="unitCost" :rules="numberRulesOrEmpty"
                                :label="$t('unitCost')"
                                :hint="$t('unitCostHint')" persistent-hint
                                :prefix="currency.hasLeftPosition() ? currency.symbol : ''"
                                :suffix="currency.hasRightPosition() ? currency.symbol : ''"
                                required/>
                  <v-text-field v-model="consumptionPerPerson" :rules="numberRules"
                                :label="$t('consumptionPerPerson')"
                                :hint="$t('consumptionPerPersonHint')"
                                persistent-hint required/>
                  <div class="same-gray mt-2">
                    {{ this.$t('processingSpeed') }}: {{ this.processingSpeed }}
                  </div>
                  <v-slider v-model="processingSpeed" tick-size=0 :min="1" :max="5" step="0.1"
                            :hint="$t('processingSpeedHint')" persistent-hint required/>
                  <dynameat-modal-header :title="$t('productPrices')"/>
                  <v-text-field v-model="minRangePrice" :rules="numberRules"
                                :label="$t('minRangePrice')"
                                :hint="$t('minRangePriceHint')" persistent-hint
                                :prefix="currency.hasLeftPosition() ? currency.symbol : ''"
                                :suffix="currency.hasRightPosition() ? currency.symbol : ''"
                                required/>
                  <v-text-field v-model="referencePrice" :rules="referencePriceRules"
                                :label="$t('referencePrice')"
                                :hint="$t('referencePriceHint')" persistent-hint
                                :prefix="currency.hasLeftPosition() ? currency.symbol : ''"
                                :suffix="currency.hasRightPosition() ? currency.symbol : ''"
                                required ref="referencePrice" readonly class="d-none"/>
                  <v-text-field v-model="maxRangePrice" :rules="numberRules"
                                :label="$t('maxRangePrice')"
                                :hint="$t('maxRangePriceHint')" persistent-hint
                                :prefix="currency.hasLeftPosition() ? currency.symbol : ''"
                                :suffix="currency.hasRightPosition() ? currency.symbol : ''"
                                required/>
                  <v-select v-model="groupOfProductPricing" :rules="notNullRule"
                            :items="groupOfProductPricingList"
                            :label="$t('groupOfProductPricing')" item-value="guid" item-text="name"
                            :hint="$t('groupOfProductPricingHint')" persistent-hint required
                            chips/>
                  <v-switch v-model="ignoreDynamicVisibility" class="mb-0" dense
                            :label="$t('ignoreDynamicVisibility')"/>
                </div>
              </transition>
            </div>
          </transition>
          <dynameat-modal-buttons @cancel="onCancel" @confirm="onConfirm"
                                  :confirmDisabled="confirmButtonDisabled"
                                  :confirmText="$t('confirm')"/>
        </v-form>
      </v-container>
    </v-card>
    <master-subordinate-product-modal :visible="subordinateProductModalVisible"
                                      :product-prop="subordinateProductToEdit"
                                      @close="closeSubordinateModal"/>
  </v-dialog>
</template>

<script>

import {
  imageFileType,
  maxChars,
  maxSize,
  notEmptyObject,
  notEmptyString,
  notNull,
  notValidNumber,
  notValidNumberOrEmpty,
  notValidPercentage,
  videoFileType,
  numberPattern
} from '@core/helpers/formValidators';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import { Components, MapActions, MapGetters } from '@core/helpers/decorators';
import DynameatConfirmationModal from '@dynameat/components/DynameatConfirmationModal';
import DynameatModalHeader from '@dynameat/components/DynameatModalHeader';
import DynameatModalButtons from '@dynameat/components/DynameatModalButtons';
import DynameatAutocomplete from '@dynameat/components/DynameatAutocomplete';
import { createErrorNotification, createSuccessNotification, createWarningNotification } from '@ulibs/unnotificationsqueue';
import cloneDeep from 'lodash/cloneDeep';
import { MODEL_INSTANCES_LANGUAGES } from '@core/constants';
import { productTextFilter } from '@core/mixins';
import DynameatLangugageFieldGenerator from '@dynameat/components/DynameatLanguageFieldGenerator';
import MasterSubordinateProductModal from './MasterSubordinateProductModal.vue';

@Component
@Components({
  DynameatConfirmationModal,
  DynameatModalHeader,
  MasterSubordinateProductModal,
  DynameatModalButtons,
  DynameatAutocomplete,
  DynameatLangugageFieldGenerator
})
@MapGetters(['masterFeatureList', 'masterSaleFormatList', 'masterProductList', 'groupOfProductPricingList',
  'selectedPointOfSale', 'pointOfSaleLanguages', 'productMasterList', 'currency', 'masterTagList'])
@MapActions(['addNotification', 'masterFeatureListRequest', 'modifyNewProducts', 'removeNotificationById',
  'updateMasterProductRequest', 'updateMasterProductSaleFormats', 'masterTagsListRequest'])
export default class MasterProductModal extends Vue {
  @Prop({ type: Boolean, default: false }) visible;

  @Prop({ type: Object, default: () => ({}) }) productProp;

  mainLanguage = MODEL_INSTANCES_LANGUAGES[0];

  product = null;

  valid = false;

  confirmModalVisible = false;

  confirmButtonDisabled = false;

  advancedOptions = false;

  // Default fields

  commercialNames = {};

  commercialDescriptions = {};

  longCommercialDescriptions = {};

  outOfStock = false;

  // Advanced fields

  unitCost = '0.0';

  referencePrice = '0.0';

  imageFile = null;

  videoFile = null;

  masterSaleFormat = null;

  groupOfProductPricing = null;

  productSaleFormats = [];

  features = [];

  tags = [];

  maxRangePrice = '0.0';

  minRangePrice = '0.0';

  processingSpeed = '0.0';

  consumptionPerPerson = '0.0';

  soldByWeight = false;

  saleWeight = '0.0';

  isManaged = false;

  isNew = false;

  subordinateProductModalVisible = false;

  deleteSaleFormatsModalVisible = false;

  saleFormatName = ''

  indexProductSaleFormats = 0;

  subordinateProductToEdit = {};

  ignoreDynamicVisibility = false;

  productMaster = '';

  async created() {
    await this.masterFeatureListRequest();
    await this.masterTagsListRequest();
  }

  get canEditSaleFormats() {
    return !this.selectedPointOfSale.useSaleFormats;
  }

  get imageHint() {
    if (this.image) {
      return this.$t('imageHintExisting');
    }
    return this.$t('imageHint');
  }

  get videoHint() {
    if (this.image) {
      return this.$t('videoHintExisting');
    }
    return this.$t('videoHint');
  }

  get defaultProductImg() {
    // eslint-disable-next-line global-require
    return require('@dynameat/assets/images/dynameat-logo-secondary.png');
  }

  get title() {
    return this.productProp ? this.productTitle : this.$t('errorInProduct');
  }

  get productTitle() {
    const name = `${this.productProp.name} (${this.productProp.id_external})`
    const amount = this.productProp.first_price;
    const { symbol } = this.currency;
    const left = this.currency.hasLeftPosition();
    const productPrice = (left ? [symbol, amount] : [amount, symbol]).join(' ');
    return name + ' - (' + productPrice + ')';
  }

  get availableLanguages() {
    return this.pointOfSaleLanguages;
  }

  get subordinateMasterFormats() {
    if (this.masterSaleFormat && this.masterSaleFormatList) {
      return this.getSaleFormatListForMasterGuid(this.masterSaleFormat);
    }
    return [];
  }

  get mainSaleFormatList() {
    return this.masterSaleFormatList.filter((el) => el.order === 0);
  }

  get numberRules() {
    return [notValidNumber(this.$t('invalidNumberError'))];
  }

  get numberRulesOrEmpty() {
    return [notValidNumberOrEmpty(this.$t('invalidNumberError'))];
  }

  get notNullRule() {
    return [notNull(this.$t('groupOfProductPricingError'))];
  }

  get shortTextRulesOrEmpty() {
    return {
      alt1: [maxChars(this.$t('tooLongText'), 128), notEmptyString(this.$t('emptyFieldError'))],
      alt2: [maxChars(this.$t('tooLongText'), 128)],
      alt3: [maxChars(this.$t('tooLongText'), 128)]
    };
  }

  get longTextRules() {
    return {
      alt1: [maxChars(this.$t('tooLongText'), 256)],
      alt2: [maxChars(this.$t('tooLongText'), 256)],
      alt3: [maxChars(this.$t('tooLongText'), 256)]
    };
  }

  get percentageRules() {
    return [notValidPercentage(this.$t('invalidPercentage'), 1, 1000)];
  }

  get imageRules() {
    return [maxSize(this.$t('fileSizeError'), 2000000), imageFileType(this.$t('fileFormatError'))];
  }

  get videoRules() {
    return [maxSize(this.$t('fileVideoSizeError'), 10000000), imageFileType(this.$t('fileFormatError'))];
  }

  get extraText() {
    return this.advancedOptions ? this.$t('defaultSettings') : this.$t('advancedSettings');
  }

  get showSaleFormatPrependIcon() {
    return (this.$vuetify.breakpoint.mdAndUp) ? 'mdi-database-search' : '';
  }

  get showSaleFormatAppendIcon() {
    return (this.$vuetify.breakpoint.mdAndUp && Object.keys(this.productSaleFormats).length > 0) ? 'mdi-pencil' : '';
  }

  get referencePriceRules() {
    this.$nextTick(() => {
      this.$refs.referencePrice?.validate(true);
    });
    return [notValidNumber(this.$t('invalidNumberError')), this.referencePriceBetween];
  }

  get referencePriceBetween() {
    let maxPrice = parseFloat(this.maxRangePrice);
    maxPrice = !Number.isNaN(maxPrice) ? maxPrice : Number.POSITIVE_INFINITY;
    let minPrice = parseFloat(this.minRangePrice);
    minPrice = !Number.isNaN(minPrice) ? minPrice : Number.NEGATIVE_INFINITY;
    return (str = '') => (typeof str === 'string'
      && !Number.isNaN(str)
      && !Number.isNaN(parseFloat(str))
      && numberPattern.test(str)
      && maxPrice >= parseFloat(str)
      && parseFloat(str) >= minPrice
    ) || this.$t('referencePriceBetween');
  }

  get uniqueSaleFormatRules() {
    let relatedProducts;
    if (this.productProp) {
      relatedProducts = [...Object.values(this.productSaleFormats), this.productProp.guid];
    } else {
      relatedProducts = [];
    }
    return [(formatGuid) => (!this.masterProductList.some((el) => Object.values(el.sale_formats).includes(formatGuid) && !relatedProducts.includes(el.guid))) || this.$t('existingSaleFormat')];
  }

  get notEmptyObject() {
    return [notEmptyObject(this.$t('emptyFieldError'))];
  }

  get productsToSearch() {
    const missingProducts = Object.values(this.productSaleFormats).filter((saleFormat) => this.masterProductList.filter((product) => product.guid === saleFormat).length === 0);
    // Remove self from search to avoid a subordinate sale format loop
    const allProducts = this.masterProductList.filter((el) => el.guid !== this.productProp?.guid);
    if (missingProducts.length > 0) {
      return [...allProducts, ...missingProducts.map((product) => ({
        guid: product,
        name: this.$t('missingProduct'),
        is_missing: true,
        getFirstName() {
          return this.name;
        }
      }))];
    }
    return allProducts;
  }

  switchAdvancedOptions() {
    this.advancedOptions = !this.advancedOptions;
  }

  getSaleFormatListForMasterGuid(masterSaleFormatGuid) {
    const productMasterFormat = this.masterSaleFormatList.find((el) => el.guid === masterSaleFormatGuid);
    return this.masterSaleFormatList.filter(
      (el) => el.guid !== productMasterFormat?.guid && el.group === productMasterFormat?.group
    ).sort((a, b) => a.order - b.order);
  }

  getProductFromGuid(guid) {
    return this.masterProductList.find((el) => el.guid === guid);
  }

  onProductTextFilter = productTextFilter

  applyProductChanges() {
    this.availableLanguages.forEach((el) => {
      this.product[`commercial_name_${el.alternative}`] = this.commercialNames[el.alternative];
      this.product[`commercial_description_${el.alternative}`] = this.commercialDescriptions[el.alternative];
      this.product[`long_commercial_description_${el.alternative}`] = this.longCommercialDescriptions[el.alternative];
    });
    this.product.out_of_stock = this.outOfStock;
    this.product.unit_cost = this.unitCost;
    this.product.reference_price = this.referencePrice;
    this.product.image = this.imageFile;
    this.product.video = this.videoFile;
    this.product.master_sale_format = this.masterSaleFormat;
    this.product.group_of_product_pricing_guid = this.groupOfProductPricing;

    // Keep just the sale formats that were seen by the user
    const saleFormatGuids = this.subordinateMasterFormats.map((format) => format.guid);
    this.product.sale_formats = Object.fromEntries(Object.entries(this.productSaleFormats).filter((entry) => saleFormatGuids.includes(entry[0])));
    this.product.features = this.features;
    this.product.tags = this.tags;
    this.product.max_range_price = this.maxRangePrice;
    this.product.min_range_price = this.minRangePrice;
    this.product.processing_speed = this.processingSpeed;
    this.product.consumption_per_person = this.consumptionPerPerson;
    this.product.sold_by_weight = this.soldByWeight;
    this.product.sale_weight_index = this.saleWeight;
    this.product.is_managed = this.isManaged;
    this.product.is_new = false;
    this.product.is_menu_enabled = true;
    this.product.ignore_dynamic_visibility = this.ignoreDynamicVisibility;
    this.product.product_master = this.productMaster;
  }

  loadProductChanges(updatedProduct) {
    this.availableLanguages.forEach((el) => {
      this.commercialNames[el.alternative] = updatedProduct[`commercial_name_${el.alternative}`];
      this.commercialDescriptions[el.alternative] = updatedProduct[`commercial_description_${el.alternative}`];
      this.longCommercialDescriptions[el.alternative] = updatedProduct[`long_commercial_description_${el.alternative}`];
    });
    this.outOfStock = updatedProduct.out_of_stock;
    if (updatedProduct.unit_cost) {
      this.unitCost = String(updatedProduct.unit_cost);
    } else {
      this.unitCost = updatedProduct.cost_price ? String(updatedProduct.cost_price) : null;
    }
    this.referencePrice = updatedProduct.reference_price ? String(updatedProduct.reference_price) : null;
    this.masterSaleFormat = updatedProduct.master_sale_format;
    this.productSaleFormats = updatedProduct.sale_formats;
    this.features = (updatedProduct.features || []).map((features) => features.guid || features);
    this.tags = (updatedProduct.tags || []).map((tag) => tag.guid || tag);
    this.maxRangePrice = updatedProduct.max_range_price ? String(updatedProduct.max_range_price) : null;
    this.minRangePrice = updatedProduct.min_range_price ? String(updatedProduct.min_range_price) : null;
    this.processingSpeed = updatedProduct.processing_speed;
    this.consumptionPerPerson = updatedProduct.consumption_per_person ? String(updatedProduct.consumption_per_person) : String(1);
    this.soldByWeight = updatedProduct.sold_by_weight;
    this.groupOfProductPricing = updatedProduct.group_of_product_pricing_guid;
    this.saleWeight = updatedProduct.sale_weight_index ? String(updatedProduct.sale_weight_index) : null;
    this.isManaged = updatedProduct.is_managed;
    this.isNew = updatedProduct.is_new;
    this.imageFile = updatedProduct.image ? new File([], this.$t('previousFile')) : null;
    this.videoFile = updatedProduct.video ? new File([], this.$t('previousFile')) : null;
    this.ignoreDynamicVisibility = updatedProduct.ignore_dynamic_visibility;
    this.productMaster = updatedProduct.product_master;
    // Force loading of rules
    // eslint-disable-next-line
    this.referencePriceRules;
  }

  onConfirm() {
    // eslint-disable-next-line prefer-destructuring
    this.$refs.form?.validate();
    if (this.valid) {
      this.onOpenConfirmModal();
    } else {
      this.addNotification(createErrorNotification(this.$t('validationError'), { id: 'masterProductValidationError' }, 1500));
      // Uncomment to see the inputs with errors
      // console.log(this.$refs.form.inputs.filter((i) => this.$refs.form.errorBag[i._uid]).map((comp) => comp.label));
    }
  }

  onCancel() {
    this.$emit('close');
    this.clearOwnData();
  }

  clearOwnData() {
    this.advancedOptions = false;
    this.commercialNames = {};
    this.commercialDescriptions = {};
    this.longCommercialDescriptions = {};
    this.outOfStock = false;
    this.unitCost = '0.0';
    this.referencePrice = '0.0';
    this.imageFile = null;
    this.videoFile = null;
    this.masterSaleFormat = null;
    this.productSaleFormats = [];
    this.features = [];
    this.tags = [];
    this.maxRangePrice = '0.0';
    this.minRangePrice = '0.0';
    this.processingSpeed = '0.0';
    this.consumptionPerPerson = '0.0';
    this.soldByWeight = false;
    this.saleWeight = 1;
    this.isManaged = false;
    this.isNew = false;
    this.isMenuEnabled = false;
    this.subordinateProductModalVisible = false;
    this.deleteSaleFormatsModalVisible = false;
    this.saleFormatName = '';
    this.groupOfProductPricing = null;
    this.indexProductSaleFormats = 0;
    this.ignoreDynamicVisibility = false;
    this.productMaster = '';
  }

  onOpenConfirmModal() {
    this.confirmModalVisible = true;
  }

  onCloseConfirmModal() {
    this.confirmModalVisible = false;
  }

  async onEditProduct() {
    this.confirmButtonDisabled = true;
    this.confirmModalVisible = false;
    const oldProductIsNew = this.product.is_new;
    this.applyProductChanges();
    if (oldProductIsNew) await this.modifyNewProducts(-1);
    await this.editProduct(this.product);
    this.$emit('close', this.product);
    this.confirmButtonDisabled = false;
    this.clearOwnData();
  }

  onEditSubordinateProduct(subordinateProductToEdit) {
    if (subordinateProductToEdit && !subordinateProductToEdit.is_missing) {
      this.subordinateProductToEdit = subordinateProductToEdit;
      this.subordinateProductModalVisible = true;
    }
  }

  async editProduct(product) {
    try {
      if ((!this.productProp?.is_managed && product.is_managed) || (this.productProp?.is_managed && !product.is_managed)) {
        this.addNotification(createWarningNotification(this.$t('saveDelay'), {}, 15000));
      }
      if (this.product.is_managed && ((this.productProp?.min_range_price !== this.product.min_range_price) || (this.productProp?.max_range_price !== this.product.max_range_price))) {
        this.addNotification(createWarningNotification(this.$t('saveDelay'), {}, 15000));
      }
      await this.updateMasterProductSaleFormats(product);
      await this.updateMasterProductRequest({ productToUpdate: product });
      this.addNotification(createSuccessNotification(this.$t('saveProductSuccess'), {}, 3000));
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('saveProductError')));
    } finally {
      this.productToEdit = null;
      this.productModalVisible = false;
    }
  }

  onRemoveSubordinateProduct(subordinateProductIndex) {
    if (this.isLastSubordinateSaleFormat(subordinateProductIndex)) this.openModalToManageDeleteSaleFormats(subordinateProductIndex);
    else this.deleteProductSaleFormats(subordinateProductIndex);
  }

  isLastSubordinateSaleFormat(index) {
    // - 1 to fit length with index
    return Object.keys(this.productSaleFormats).length - 1 > index;
  }

  openModalToManageDeleteSaleFormats(index) {
    this.deleteSaleFormatsModalVisible = true;
    this.indexProductSaleFormats = index;
    this.getSubordinateSaleFormatName();
  }

  getSubordinateSaleFormatName() {
    const masterFormat = this.masterSaleFormatList.find((format) => format.guid === this.masterSaleFormat);
    const subordinateSaleFormatList = this.masterSaleFormatList.filter((format) => format.group === masterFormat.group && format.guid !== this.masterSaleFormat);
    this.saleFormatName = subordinateSaleFormatList[this.indexProductSaleFormats]?.name;
  }

  confirmDeleteSaleFormats() {
    this.closeModalToManageDeleteSaleFormats();
    this.deleteProductSaleFormats(this.indexProductSaleFormats);
  }

  cancelDeleteSaleFormats() {
    this.closeModalToManageDeleteSaleFormats();
  }

  closeModalToManageDeleteSaleFormats() {
    this.deleteSaleFormatsModalVisible = false;
  }

  deleteProductSaleFormats(index) {
    // Remove all indexes from this one
    const filterProductSaleFormatsEntries = Object.entries(this.productSaleFormats).slice(0, index);
    // FromEntries to get the correct format of productSaleFormats {guidsaleformat: guidproduct}
    this.productSaleFormats = Object.fromEntries(filterProductSaleFormatsEntries);
  }

  closeSubordinateModal() {
    this.subordinateProductModalVisible = false;
  }

  moveSaleFormatsToNewMaster(oldFormatGuid) {
    // Try to move all existing sale formats to new master structure
    const oldSaleFormats = this.getSaleFormatListForMasterGuid(oldFormatGuid);
    const newSaleFormats = this.subordinateMasterFormats;
    if (oldSaleFormats.length === newSaleFormats.length) {
      oldSaleFormats.forEach((msf, index) => {
        if (this.productSaleFormats[msf.guid]) {
          this.productSaleFormats[newSaleFormats[index].guid] = this.productSaleFormats[msf.guid];
        }
        delete this.productSaleFormats[msf.guid];
      });
    } else {
      this.addNotification(createErrorNotification(this.$t('saleFormatLengthError'), { id: 'saleFormatLengthError' }));
    }
  }

  @Watch('masterSaleFormat')
  onMasterSaleFormatChanged(newFormatGuid, oldFormatGuid) {
    // If user can't edit sale format structure but changes master sale group
    if (oldFormatGuid !== null && newFormatGuid !== null && !this.canEditSaleFormats) {
      this.moveSaleFormatsToNewMaster(oldFormatGuid);
    }
  }

  @Watch('productProp')
  onProductPropChange(updatedProduct) {
    if (updatedProduct) {
      this.clearOwnData();
      this.loadProductChanges(updatedProduct);
    }
  }

  @Watch('minRangePrice')
  onMinRangePriceChange(val) {
    this.referencePrice = val;
  }

  @Watch('visible')
  onVisible(val) {
    if (val) {
      this.product = cloneDeep(this.productProp);
      if (this.isNew) {
        this.advancedOptions = true;
      }
    }
  }
}
</script>
<style scoped lang="scss">

.form-inputs {
  > div {
    margin-bottom: 15px;
  }
}

.chip-ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.h-scroll {
  overflow-y: hidden;
  overflow-x: auto;
}

.no-wrap {
  text-overflow: initial;
  overflow: initial;
  white-space: nowrap;
}

.progress-enter-active, .progress-leave-active {
  transition: all 0.3s ease;
}

.progress-enter, .progress-leave-active {
  opacity: 0;
}

.word-break {
  word-break: break-word;
}

.same-gray {
  color: rgba(0, 0, 0, 0.6)
}

.pointer {
  cursor: pointer;
}

.error-chip {
  background: #ff000054 !important;
}
</style>

<style>
.master-product-form .v-text-field__details {
  padding-top: 5px;
}

.master-product-form .v-messages__message {
  line-height: 14px;
  font-size: 13px
}

.master-product-form .master-product-input .v-messages {
  min-height: 0;
}

.required label::after {
  content: " *";
  color: red;
}
</style>
